import * as React from "react";

const CheckmarkIcon = (props: any) => (
  <svg width="32" height="32" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
    <mask id="mask0_254_5412" maskUnits="userSpaceOnUse" x="0" y="0" width="42" height="43">
      <rect width="42.0004" height="42.0004" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_254_5412)">
      <path d="M17.5001 28.7002L10.5 21.7001L12.95 19.2501L17.5001 23.8001L29.0502 12.25L31.5002 14.7L17.5001 28.7002Z" fill="#1B1817" />
    </g>
  </svg>

);

export default CheckmarkIcon;
